<script lang="ts">
	import { getStorageContext } from '../storage/storageContext'
	import { getDownloadURL, ref } from 'firebase/storage'
	import { onMount } from 'svelte'

	interface Props {
		path: string
		alt?: string
		width?: number
		height?: number
		cover?: boolean
		contain?: boolean
		children?: import('svelte').Snippet
	}

	let {
		path,
		alt = '',
		width = 70,
		height = 70,
		cover = false,
		contain = false,
		children,
	}: Props = $props()

	let imgSrc: string = $state(null)
	let firebaseImageUrl: string

	function isStagingOrProduction(path: string) {
		return (
			path.startsWith('/v0/b/trackdesk-com-production-data/') ||
			path.startsWith('/v0/b/trackdesk-com-staging-data/')
		)
	}

	onMount(async () => {
		try {
			const storage = getStorageContext()
			const imageRef = ref(storage, path)
			firebaseImageUrl = await getDownloadURL(imageRef)

			const imgUrl = new URL(firebaseImageUrl)
			const imagePath = [imgUrl.pathname, imgUrl.search].join('')

			if (isStagingOrProduction(imagePath)) {
				imgSrc = `https://trackdesk.twic.pics/v1/${cover ? 'cover' : 'contain'}=${width}x${height}/media:${imagePath.slice(1)}`
			} else {
				imgSrc = firebaseImageUrl
			}
		} catch (_e) {}
	})

	function handleError() {
		imgSrc = firebaseImageUrl
	}
</script>

{#if imgSrc}
	<img
		class={cover ? 'h-full w-full object-cover' : contain ? 'h-full w-full object-contain' : ''}
		{alt}
		{height}
		onerror={handleError}
		src={imgSrc}
		{width}
	/>
{:else if children}{@render children()}{:else}
	{alt}
{/if}
